import { map } from 'lodash';

import {
  COMPANY_SIZE,
  ORDER_RADIUS,
  RATING_CATEGORY,
  SUBCONTRACTOR_PRICING_TIER,
} from '~/__gql__/graphql';

export const orderedCompanySizes = [
  COMPANY_SIZE.size_1_4,
  COMPANY_SIZE.size_5_9,
  COMPANY_SIZE.size_10_19,
  COMPANY_SIZE.size_20_49,
  COMPANY_SIZE.size_50_99,
  COMPANY_SIZE.size_100_199,
  COMPANY_SIZE.size_200_499,
  COMPANY_SIZE.size_500plus,
];

export const orderedCompanySizeRangeStops = ['1', '5', '10', '20', '50', '100', '200'];

export const orderedOrderRadiuses = [
  ORDER_RADIUS.km_20,
  ORDER_RADIUS.km_50,
  ORDER_RADIUS.km_100,
  ORDER_RADIUS.km_200,
  ORDER_RADIUS.km_350,
  ORDER_RADIUS.km_500,
  ORDER_RADIUS.km_750,
  ORDER_RADIUS.km_1000,
  ORDER_RADIUS.km_2000,
  ORDER_RADIUS.km_3000,
  ORDER_RADIUS.unlimited,
];

export const orderedRatingCategories = [
  RATING_CATEGORY.availability,
  RATING_CATEGORY.bidQuality,
  RATING_CATEGORY.priceLevel,
  RATING_CATEGORY.negotiation,
  RATING_CATEGORY.communication,
  RATING_CATEGORY.qualityOfWork,
  RATING_CATEGORY.timeManagement,
  RATING_CATEGORY.cleanliness,
  RATING_CATEGORY.reliability,
  RATING_CATEGORY.occupationalSafety,
  RATING_CATEGORY.environmentalAspects,
  RATING_CATEGORY.adherenceToDeadlines,
  RATING_CATEGORY.addenda,
  RATING_CATEGORY.invoicingAndBilling,
] as const;

export const LABEL_BY_TIER: Record<SUBCONTRACTOR_PRICING_TIER, string> = {
  [SUBCONTRACTOR_PRICING_TIER.tier1]: '< 10',
  [SUBCONTRACTOR_PRICING_TIER.tier2]: '10-19',
  [SUBCONTRACTOR_PRICING_TIER.tier3]: '20-49',
  [SUBCONTRACTOR_PRICING_TIER.tier4]: '50-99',
  [SUBCONTRACTOR_PRICING_TIER.tier5]: '100+',
};

export const TIER_OPTIONS = map(LABEL_BY_TIER, (label, key) => ({ label, value: key }));
